var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { ControlWrap } from "../wrap";
export function Control(props) {
    const { valid, highlighted } = props, inputProps = __rest(props, ["valid", "highlighted"]);
    if (props === null || props === void 0 ? void 0 : props.label) {
        return React.createElement(ControlWrap, { label: props.label, valid: valid, highlighted: highlighted },
            React.createElement(Input, Object.assign({}, inputProps)));
    }
    return React.createElement(Input, Object.assign({}, inputProps));
}
const Input = ({ type, value, onChange, onBlur, disabled, placeholder }) => React.createElement("input", { type: type || "text", disabled: disabled, value: value, onBlur: onBlur, onChange: (ev) => onChange && onChange(ev.target.value), placeholder: placeholder, className: "ltg-control" });
